import {Component, Input} from '@angular/core';
import {Services} from '../../../../../../model/services';
import {TextsComponent} from '../../../../../elements/texts/texts.component';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-service-el',
  imports: [
    TextsComponent,
    NgIf
  ],
  templateUrl: './service-el.component.html',
  styleUrl: './service-el.component.scss'
})
export class ServiceElComponent {
  @Input() service: Services = new Services();

  getBackground() {
    let filter = '';
    if (this.service.filter != undefined) {
      filter = this.service.filterNumber
        ? `filter: grayscale(${this.service.filterNumber}%);`
        : 'filter: grayscale(100%);';
    }
    if (!this.service.img) {
      return 'background: var(--background-color);';
    } else {
      return `
      background: url("${this.service.img}") no-repeat fixed center / cover;
      ${filter}
    `;
    }
  }

  getVail() {
    return !this.service.vail ? '' : `background: rgba(0, 0, 0, ${this.service.vail});`
  }
}
